<template>
  <el-table
    :data="events"
    stripe
  >
    <el-table-column
      label="Event"
      :formatter="row => $filters.titleize(row.type || '-')"
    />

    <el-table-column
      label="User"
      :formatter="row => $_.get(row, 'profile.name', '-')"
    />

    <el-table-column
      label="Created At"
      :formatter="row => row.created_at ? $moment(row.created_at).format('DD/MM/YYYY hh:mm a') : '-'"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    events: {
      type: Array,
      required: true
    }
  }
}
</script>
